import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import environment from "../../environment/environment";
const BASE_URL = `${environment.API}`;
//axios.defaults.headers.common.Authorization = `Bearer ${}`;

export const getRates = createAsyncThunk(
  "rates/getRates",
  async (params, { rejectWithValue }) => {
    try {
      params.authorization = localStorage.getItem("userToken");
      const response = await axios.post(
        `${BASE_URL}/Rates/getRates`,
        params
      );
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const saveRates = createAsyncThunk(
  "rates/saveRates",
  async (params, { rejectWithValue }) => {
    try {
      params.authorization = localStorage.getItem("userToken");
      const response = await axios.post(
        `${BASE_URL}/Rates/saveRates`,
        params
      );
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
